export default [
  ['AL', 'Alabama', 'us_state'],
  ['AK', 'Alaska', 'us_state'],
  ['AZ', 'Arizona', 'us_state'],
  ['AR', 'Arkansas', 'us_state'],
  ['CA', 'California', 'us_state'],
  ['CO', 'Colorado', 'us_state'],
  ['CT', 'Connecticut', 'us_state'],
  ['DE', 'Delaware', 'us_state'],
  ['DC', 'District of Columbia', 'us_state'],
  ['FL', 'Florida', 'us_state'],
  ['GA', 'Georgia', 'us_state'],
  ['HI', 'Hawaii', 'us_state'],
  ['ID', 'Idaho', 'us_state'],
  ['IL', 'Illinois', 'us_state'],
  ['IN', 'Indiana', 'us_state'],
  ['IA', 'Iowa', 'us_state'],
  ['KS', 'Kansas', 'us_state'],
  ['KY', 'Kentucky', 'us_state'],
  ['LA', 'Louisiana', 'us_state'],
  ['ME', 'Maine', 'us_state'],
  ['MD', 'Maryland', 'us_state'],
  ['MA', 'Massachusetts', 'us_state'],
  ['MI', 'Michigan', 'us_state'],
  ['MN', 'Minnesota', 'us_state'],
  ['MS', 'Mississippi', 'us_state'],
  ['MO', 'Missouri', 'us_state'],
  ['MT', 'Montana', 'us_state'],
  ['NE', 'Nebraska', 'us_state'],
  ['NV', 'Nevada', 'us_state'],
  ['NH', 'New Hampshire', 'us_state'],
  ['NJ', 'New Jersey', 'us_state'],
  ['NM', 'New Mexico', 'us_state'],
  ['NY', 'New York', 'us_state'],
  ['NC', 'North Carolina', 'us_state'],
  ['ND', 'North Dakota', 'us_state'],
  ['OH', 'Ohio', 'us_state'],
  ['OK', 'Oklahoma', 'us_state'],
  ['OR', 'Oregon', 'us_state'],
  ['PA', 'Pennsylvania', 'us_state'],
  ['RI', 'Rhode Island', 'us_state'],
  ['SC', 'South Carolina', 'us_state'],
  ['SD', 'South Dakota', 'us_state'],
  ['TN', 'Tennessee', 'us_state'],
  ['TX', 'Texas', 'us_state'],
  ['UT', 'Utah', 'us_state'],
  ['VT', 'Vermont', 'us_state'],
  ['VA', 'Virginia', 'us_state'],
  ['WA', 'Washington', 'us_state'],
  ['WV', 'West Virginia', 'us_state'],
  ['WI', 'Wisconsin', 'us_state'],
  ['WY', 'Wyoming', 'us_state'],
  ['AS', 'American Samoa', 'us_territory'],
  ['GU', 'Guam', 'us_territory'],
  ['MP', 'Northern Mariana Islands', 'us_territory'],
  ['PR', 'Puerto Rico', 'us_territory'],
  ['VI', 'Virgin Islands', 'us_territory'],
];
